'use strict';

var dateFns = require('date-fns');
var parsers = require('../parsers.cjs');

const addMillisecondsToISOTimePart = ({
  isoTimePart,
  duration
}) => {
  const date = parsers.isoTimePartToDate(isoTimePart);
  const result = dateFns.addMilliseconds(date, duration);
  return parsers.dateToISOTimePart(result);
};

module.exports = addMillisecondsToISOTimePart;
//# sourceMappingURL=addMillisecondsToISOTimePart.cjs.map
